module.exports = __webpack_public_path__ + "img/home.8bc6ddf8.jpg";